import styled from '@emotion/styled';
import { Box, Button, Card, Grid, IconButton, Typography } from '@mui/material';

export const BoxContainer = styled(Box)((theme) => ({
  marginInline: 'auto',
  maxHeight: '1600px',
  position: 'relative',
  maxWidth: '100vw',
  minHeight: '100vh',
  padding: '20px',
}));

export const BoxContainerPhoto = styled(Box)((theme) => ({
  padding: '24px',
  // paddingBottom: '40px',
  borderRadius: '8px',
  backgroundColor: '#FFF7FC',
  maxWidth: '50vw',
  '@media (min-width: 1024px) and (min-height: 1366px)': {
    maxWidth: '60vw',
  },
}));

export const BoxContainerVideo = styled(Box)((theme) => ({
  maxWidth: '50vw',
  '@media (min-width: 1024px) and (min-height: 1366px)': {
    maxWidth: '60vw',
  },
}));
export const IconButtonSound = styled(IconButton)(() => ({
  position: 'relative',
  left: '50px',
  top: '50px',
  zIndex: '10',
}));

export const BoxContainerProgress = styled(Box)((theme) => ({
  marginLeft: '40px',
  marginRight: '40px',
  position: 'relative',
  top: '-55px',
  width: '89%',
}));
export const TitleCover = styled(Typography)((theme) => ({
  color: '#1D1D1D',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  paddingBottom: '16px',
}));

export const GridContainerPhotos = styled(Grid)((theme) => ({
  background: '#F7EDF4',
  padding: 8,
  borderRadius: '8px',
}));
export const CardPhoto = styled(Card)((theme) => ({
  // width: '100%',
  height: '7rem',
  objectFit: 'cover',
  borderRadius: '8px',
}));
export const CardDeletePhoto = styled(Card)((theme) => ({
  width: '24px',
  display: 'flex',
  height: '24px',
  backgroundColor: '#B44058',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 'auto',
}));
export const CardTakePhoto = styled(Card)((theme) => ({
  // width: '100%',
  height: '7rem',
  objectFit: 'cover',
  borderRadius: '8px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  background: '#EDC2E2',
}));
export const CardTakePhotoTitle = styled(Typography)((theme) => ({
  color: '#662B5C',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '24px',
}));

export const SaveCvButton = styled(Button)((theme) => ({
  margin: 'auto',
  background: '#3AA05C',
  marginTop: '2rem',
  alignSelf: 'center',
  width: '100%',
  borderRadius: '44px',
  '&:hover': {
    background: '#3AA05C',
  },
}));

export const TitleSaveButton = styled(Button)((theme) => ({
  color: '#FFF7FC',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  textTransform: 'capitalize',
}));

export const CheckCardPhoto = styled(Card)((theme) => ({
  width: '24px',
  display: 'flex',
  height: '24px',
  backgroundColor: '#A03A7E',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: 'auto',
}));
export const BoxContainerCheckDeletePhoto = styled(Box)((theme) => ({
  zIndex: 4,
  position: 'relative',
  top: '-50px',
  display: 'flex',
  width: '80%',
  justifyContent: 'space-around',
  left: '20px',
  alignItems: 'center',
}));
